import { IUser } from "src/core/users/api/users.api";

/**
 * Function for formatting a user name
 * e.g firstName (lastName)
 * @param user
 * @returns
 */
export const formatUserName = (user: IUser): string => {
  let formattedName = "";

  if (user) {
    if (user.firstName) {
      formattedName += ` ${user.firstName} ${user.lastName}`;
    }

    if (user.email) {
      formattedName += ` (${user.email})`;
    }
  }

  return formattedName;
};
